export const WIZARD_PT_BR = {
	common: {
		pointsOfSale: "Pontos de venda",
	},
	welcome: {
		title: "Boas vindas, <placeName>{{placeName}}</placeName>!",
		subtitle: "Escolha como deseja configurar sua operação.",
		skipButton: "Não quero configurar agora",
		placeIdNotFound: "Place ID não encontrado",
		features: {
			preConfiguredSteps: "Etapas com sugestões pré-configuradas",
			guidedStepsWithAI: "Passo a passo guiado com ajuda de IA",
			advancedConfigurations: "Configurações avançadas e personalizações",
			complexFeatures: "Funcionalidades mais complexas",
		},
		guidedMode: {
			title: "Criação guiada (modo simplificado)",
			subtitle: "A gente guia você passo a passo",
			buttonText: "Acessar modo simplificado",
			features: {
				basicConfigurations: "Configurações mais básicas",
				idealForSimpleOperations: "Ideal para operações mais simples e menores",
			},
		},
		advancedMode: {
			title: "Criação avançada",
			subtitle: "Mais opções e detalhes de configurações",
			buttonText: "Acessar modo avançado",
			features: {
				directConfiguration: "Configuração direta nos módulos do Dashboard",
				idealForComplexOperations: "Ideal para operações grandes e complexas",
			},
		},
	},
	container: {
		stepIndexTitle: "Configure seu local",
		buttons: {
			back: "Voltar",
			close: "Fechar",
			next: "Avançar",
			configureLater: "Configurar depois",
			finishConfiguration: "Concluir configurações",
		},
		finishConfirmation: {
			title: "Concluir configurações da operação",
			descriptionPart1: "Você está prestes a concluir a configuração desta operação.",
			descriptionPart2:
				"Um resumo final será gerado e ficará disponível para consulta a qualquer momento. Depois, você poderá revisar e editar quando precisar.",
			cancelButton: "Cancelar",
			confirmButton: "Concluir configurações",
			successMessage: "Configurações salvas com sucesso!",
		},
		closeModalConfirmation: {
			title: "Sair da configuração sem salvar?",
			description:
				"Ao fechar agora, as informações configuradas até aqui não serão salvas e você perderá o progresso. Deseja continuar?",
			cancelButton: "Continuar configurando",
			confirmButton: "Sair sem salvar",
		},
		steps: {
			basicInformation: {
				title: "Informações básicas",
				subtitle: "Configure o tipo da operação",
				operationType: {
					title: "Como os clientes irão <highlight>comprar</highlight>?",
					subtitle: "Escolha um ou mais formatos que se aplicarão á esta operação.",
					alert: {
						message: "Estas opções já vem marcadas do contrato da sua operação.",
						description: "Você pode manter como está ou ajustar, se desejar.",
					},
					subStepTitle: "Tipo de operação",
				},
				funcionalities: {
					title: "Quais serão as <highlight>funcionalidades</highlight> desta operação?",
					subtitle:
						"As funcionalidades são opções com recursos que permitem configurar a operação de forma personalizada.",
					subStepTitle: "Funcionalidades",
					searchFunctionalities: "Buscar por funcionalidades",
					placeholderSearchFunctionalities: "Digite aqui a funcionalidade",
					activeLabel: "ativas",
					loadingText: "Carregando funcionalidades...",
					emptySearchResults: "Nenhuma funcionalidade encontrada",
				},
				review: {
					title:
						"Já conseguimos entender as <highlight>configurações iniciais</highlight> da operação!",
					subtitle: "De acordo com as suas respostas, o sistema irá configurar:",
					subStepTitle: "Revisão",
					reviewTitle: "Revise as respostas",
					reviewSubtitle: "Você poderá editá-las agora ou quando precisar.",
					editStep: "Editar etapa",
					operationTypeLabel: "Tipo de operação",
					functionalitiesLabel: "Funcionalidades",
					notInformed: "Não informado",
					selectedCount: "{{count}} selecionada(s)",
					viewFunctionalities: "Ver funcionalidades",
				},
			},
			pointsOfSale: {
				title: "Pontos de venda",
				subtitle: "Configure os locais de venda",
			},
			menu: {
				title: "Cardápio",
				subtitle: "Configure os produtos",
			},
			employees: {
				title: "Funcionários",
				subtitle: "Configure a equipe da operação",
			},
		},
		operationTypes: {
			token: {
				label: "Ficha",
				description: "Cliente troca ficha por produto",
			},
			cashlessPrepaid: {
				label: "Cashless (pré-pago)",
				description: "Cliente carrega crédito num cartão",
			},
			cashlessPostpaid: {
				label: "Cashless (pós-pago)",
				description: "Cliente paga num cartão após o consumo",
			},
			directSale: {
				label: "Venda direta no bar",
				description: "Cliente paga pelo produto diretamente",
			},
			tables: {
				label: "Mesas",
				description: "Cliente realiza o pedido para os garçons",
			},
		},
		summary: {
			title: "Resumo da configuração do <placeName>{{placeName}}</placeName>!",
			subtitle:
				"Edite respostas, volte etapas ou acesse configurações avançadas a qualquer momento.",
			editStep: "Editar etapa",
			operationType: "Tipo de operação",
			functionalities: "Funcionalidades",
			viewFunctionalities: "Ver funcionalidades",
			advancedConfigurations: "Configurações avançadas de Funcionalidades",
			notInformed: "Não informado",
			selectedCount: "{{count}} selecionada(s)",
			pendingAction: "Ação pendente",
			loading: "Carregando configurações...",
			placeIdNotFound: "Place ID não encontrado",
			errorLoading: "Erro ao carregar dados",
		},
	},
	components: {
		pdvCard: {
			menu: {
				edit: "Editar",
				remove: "Remover",
				ariaLabel: "Menu de opções",
			},
			buttons: {
				cancel: "Cancelar",
				save: "Salvar",
			},
		},
		productCard: {
			menu: {
				edit: "Editar",
				remove: "Remover",
				ariaLabel: "Menu de opções",
			},
		},
		menuCard: {
			productsCount: "{{count}} produtos",
		},
		empty: {
			title: "Ainda não tem nada por aqui",
			description: "Parece que você ainda não tem nada por aqui.",
			button: "Adicionar novo item",
		},
		attachmentsFile: {
			loadingText: "Aguarde enquanto enviamos o arquivo...",
			dragText: "Arraste e solte o arquivo",
			clickText: "ou clique para selecionar",
			fileTypeText: "Tipo de arquivo {{fileType}} até {{fileSize}}.",
			maxSizeExceeded: "O tamanho do arquivo excede o limite permitido.",
		},
		modalSelectImage: {
			productImage: "Editar imagem",
			setTagInput: "Procure pelo produto usando palavras-chave",
			confirm: "Confirmar",
			notInformed: "Nome não informado",
			selectFrom: "Selecione imagem do seu ",
			computer: "computador",
			addImage: "Adicionar imagem",
			typeOfFile: "Tipo de arquivo .jpg, .jpeg, .png até 5MB",
			errorCreatingImageUrl: "Erro ao criar URL da imagem",
		},
		employeePdvLink: {
			manualDistribution: "Distribuir manualmente",
			description:
				"Escolha para quais pontos de venda todos os <strong>{{count}} {{roleName}}</strong> irão trabalhar",
			selectedCount: "{{count}} Selecionados",
		},
	},
};
export type WizardTranslations = typeof WIZARD_PT_BR;
